import MockApi from "./mockApi";
import {API} from "./env";
import {axiosInstance} from "./httpClient";


export default class CompaniesApi {

    static getStats = () => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.get(`${API}/admin/companies/stats`, config);
    };

    static getStatsForCompany = (companyId, historyDays) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };
        const query = historyDays ? `?history=${historyDays}` : '';
        return axiosInstance.get(`${API}/admin/companies/${companyId}/stats${query}`, config);
    };

    static recomputeStats = (companyId) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };
        const query = companyId ? `?companyId=${companyId}` : '';
        return axiosInstance.post(`${API}/admin/companies/stats/recompute${query}`, {}, config);
    };

    static getAll = () => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        var config = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
            };

        return axiosInstance.get(`${API}/employers`, config);
    };

    static getCompanyByGovId = (govId) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        var config = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
            };


        return axiosInstance.get(`${API}/companies/govInfo?govId=`+govId.toString(), config);
    };

    static createEmployer = (companyJson) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;

        const {
            name,
            address,
            govId,
            employeesMonthlyTransferLimit,
            employeesCount,
            isActive,
            companyLogo,
            companyExternalId,
            companyDisplayedName,
            contactEmails,
        } = companyJson;

        // Use FormData to accommodate the file upload
        let formData = new FormData();
        formData.append('name', name);
        formData.append('address', address);
        formData.append('govId', govId);
        formData.append('employeesMonthlyTransferLimit', employeesMonthlyTransferLimit);
        formData.append('employeesCount', employeesCount);
        formData.append('isActive', isActive);
        formData.append('companyLogo', companyLogo);
        formData.append('companyExternalId', companyExternalId);
        formData.append('companyDisplayedName', companyDisplayedName);
        if (contactEmails && contactEmails.length > 0) {
            formData.append('contactEmails', contactEmails.join(','));
        }


        let config = {
            method: 'post',
            headers: {
                'Content-Type': 'multipart/form-data', // Not needed, axios sets it correctly based on formData
                'Authorization': 'Bearer ' + accessToken,
            },
        };

        return axiosInstance.post(`${API}/employers`, formData, config);
    };





    static delete = (companyId) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;

        var body = JSON.stringify({
            "id": companyId
            });

        var config = {
            method: 'delete',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            },
            data: body
            };


        return axiosInstance.delete(`${API}/employers`, config);
    };

    static update = (companyJson) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;

        var config = {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            },
        };

        return axiosInstance.post(`${API}/employers/update`, JSON.stringify(companyJson), config);
    };


    static getReports = (aDate, companyId = null) => {
        if(MockApi.IsActive) {
            return MockApi.GetCompanyReports();
        }


        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        let body = {
            payPeriod: aDate
        };
        if (companyId) {
            body['companyId'] = companyId;
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.post(`${API}/reports/get`, JSON.stringify(body), config);
    };

    static exportPayrollData = (aDate) => {
        if(MockApi.IsActive) {
            return MockApi.ExportPayrollData();
        }

        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        let body = {
            date: aDate
        };

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.post(`${API}/employer/payroll`, JSON.stringify(body), config);
    };

    static integrationsTaReport = (aDate, aCompanyId) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        let body = {
            date: aDate,
            companyId: aCompanyId
        };

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.post(`${API}/integrations/ta/report/`, JSON.stringify(body), config);
    };

    // Company Files Management Methods

    static uploadCompanyFile = (file, companyId) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        
        let formData = new FormData();
        formData.append('file', file);

        const config = {
            headers: {
                'Authorization': 'Bearer ' + accessToken,
                // Don't set Content-Type, let browser set it with boundary for multipart/form-data
            },
        };

        return axiosInstance.post(`${API}/companies/${companyId}/files`, formData, config);
    };

    static listCompanyFiles = (companyId) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        
        const config = {
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.get(`${API}/companies/${companyId}/files`, config);
    };

    static downloadCompanyFile = (companyId, fileName) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        
        const config = {
            method: 'get',
            headers: {
                'Authorization': 'Bearer ' + accessToken
            },
            responseType: 'blob' // Important for file downloads
        };

        return axiosInstance.get(`${API}/companies/${companyId}/files/${encodeURIComponent(fileName)}`, config);
    };

    static deleteCompanyFile = (companyId, fileName) => {
        let userInfo = JSON.parse(localStorage.getItem("user"));
        let accessToken = userInfo.token;
        
        const config = {
            method: 'delete',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        };

        return axiosInstance.delete(`${API}/companies/${companyId}/files/${encodeURIComponent(fileName)}`, config);
    };
}
